import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { ValidationType } from 'enums/validationType';
import { Layout } from 'modules/layout';
import { TranslatePipe } from 'pipes/translate.pipe';
import { DnsLookupService } from 'services/dns-lookup.service';
import { DnsInformationModel } from 'services/domain.service';
import { FormValidationService } from 'services/form-validation.service';

@Component({
	selector: 'lookup-domain',
	templateUrl: './lookup-domain.component.html',
	providers: [FormValidationService],
	imports: [FormsModule, Layout, CustomInputComponent, TranslatePipe]
})
export class LookupDomainComponent {
	@Output() busyChange = new EventEmitter<boolean>();
	@Output() onLookup = new EventEmitter<DnsInformationModel>();
	@Input() buttonLabel = '';
	@ViewChild('lookupButton') lookupButton?: ButtonComponent;
	validationType = ValidationType;
	domainName = '';
	constructor(private readonly dns: DnsLookupService) { }

	async lookupDomain() {
		this.busyChange.emit(true);
		const dnsInformation = await this.dns.soaLookup(this.domainName);
		this.onLookup.emit(dnsInformation);
		this.lookupButton?.reset();
		this.busyChange.emit(false);
	}
}

